import { LOGIN_PAGE } from '@/src/modules/account/received/constants'
import {
    BRAND_PAGE,
    CHECKOUT_PATH,
    DEFAULT_BUY_PAGE,
    PARTNER_BRAND_PAGE,
    PARTNER_CHECKOUT_PAGE,
    PARTNER_LOGIN_PAGE,
    PARTNER_PATH,
} from '@/src/modules/pg-plus/constants'
import { TPartnerPayload } from '@/src/modules/partners/types'

function determineCheckoutUrls(partnerData?: TPartnerPayload): {
    loginUrl: string
    checkoutUrl: string
    continueShoppingUrl: string
    backUrlBase: string
    homeUrl: string
} {
    if (partnerData) {
        // if user has single merchant name, use it to determine page paths
        const singleMerchantSlug: string =
            partnerData?.store_page_brand_slug ?? ''
        const homePage: string = singleMerchantSlug
            ? `${PARTNER_PATH}/${singleMerchantSlug}`
            : PARTNER_BRAND_PAGE

        return {
            loginUrl: PARTNER_LOGIN_PAGE,
            checkoutUrl: PARTNER_CHECKOUT_PAGE,
            continueShoppingUrl: homePage,
            backUrlBase: PARTNER_CHECKOUT_PAGE,
            homeUrl: homePage,
        }
    }

    return {
        loginUrl: LOGIN_PAGE,
        checkoutUrl: CHECKOUT_PATH,
        continueShoppingUrl: DEFAULT_BUY_PAGE,
        backUrlBase: CHECKOUT_PATH,
        homeUrl: `/`,
    }
}

export default determineCheckoutUrls
